import { z } from 'zod';

/**
 * Variant Option Schema
 * Represents a single dimension-value pair for a variant
 * Example: { name: "Flavor", value: "Lemon" }
 */
export const VariantOptionSchema = z.object({
  name: z.string().min(1, 'Option name is required'),
  value: z.string().min(1, 'Option value is required'),
});

export type VariantOption = z.infer<typeof VariantOptionSchema>;

/**
 * Item Variant Schema
 * Represents a single variant of an item with multi-dimensional options
 */
export const ItemVariantSchema = z.object({
  id: z.number().optional(),
  guid: z.string().optional(),
  number: z.number().optional(),
  options: z.array(VariantOptionSchema).min(1, 'At least one option is required for a variant'),
  displayName: z.string().optional(),
  price: z.number().nonnegative('Price must be non-negative'),
  sku: z.string().optional(),
  upc: z.string().optional(),
  barcode: z.string().optional(),
  available: z.boolean().default(true),
  calories: z.number().nonnegative().optional(),
  imageUrl: z.string().url().optional().or(z.literal('')),
  position: z.number().optional(),
});

export type ItemVariant = z.infer<typeof ItemVariantSchema>;

/**
 * Partial Item Variant Schema (for updates)
 */
export const ItemVariantDataSchema = ItemVariantSchema.partial().required({
  options: true,
  price: true,
});

export type ItemVariantData = z.infer<typeof ItemVariantDataSchema>;
